import * as React from 'react';
import { Component, inject, deps, observer } from '../lib/component';
import { style } from 'typestyle';
import {
  centerCenter, horizontal, horizontallySpaced, start, startJustified, vertical,
  verticallySpaced
} from 'csstips';
import { LoadingOverlay } from '../components/loading/overlay';
import { important, percent, px, viewHeight } from 'csx';
import { AddThisShareBox } from '../components/social/add-this-share-box';
import {PageHeader} from '../components/page-header';
import {mediaTablet, mediaMobileOnly} from '../theme/media';
import MainWrapper from '../components/main-wrapper';
const PrismicDOM = require('prismic-dom');

export interface ContactPageProps {}

@inject(deps) @observer
export class ContactPage extends Component<ContactPageProps> {
  render() {
    const model = this.props.model.page.contact;

    return (
      <MainWrapper>
        <LoadingOverlay loading={model.loading}/>
        <PageHeader
          coverImage={model.cover_image}
          dangerouslySetInnerHTML={{ __html: model.loading ? null : PrismicDOM.RichText.asHtml(model.page_title) }}
        />
        {!model.loading && (
          <div className={ContactPage.styles.container}>
            <div className={ContactPage.styles.content}>
              <h2>Follow us</h2>
              <AddThisShareBox follow={true} className={ContactPage.styles.follow}/>
              <h2>Get in touch</h2>
              <div
                dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(model.email_block) }}
              />
              <h2>Visiting us</h2>
              <div
                dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(model.address_block) }}
              />
            </div>
            <div className={ContactPage.styles.map}>
              <iframe src="https://maps.google.com/maps?q=Runway%20East,%2066%20Old%20Compton%20St,%20Soho,%20London,%20W1D%204UH,%20United%20Kingdom&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=&amp;output=embed" />
            </div>
          </div>
        )}
      </MainWrapper>
    )
  }

  static styles = {
    container: style(
      mediaMobileOnly({
        ...vertical,
        ...verticallySpaced(30)
      }),
      mediaTablet({
        ...horizontal,
        ...horizontallySpaced(30)
      })
    ),
    content: style(
      {
        flex: 1,
        padding: px(20),
        $nest: {
          '& h2': {
            margin: '60px 0 20px'
          },
          '& h2:first-child': {
            marginTop: 0
          }
        }
      },
      mediaTablet({
        padding: px(80)
      })
    ),
    map: style(
      {
        ...centerCenter,
        flex: 1,
        height: px(320),
        $nest: {
          '& iframe': {
            border: 0,
            width: percent(100),
            height: percent(100),
          }
        }
      },
      mediaTablet({
        height: viewHeight(90)
      })
    ),
    follow: style({
      display: important('inline-flex')
    })
  }
}